import { useNavigate, useLocation } from "react-router-dom";
// Removed unused useState and useEffect imports
import PageBanner from "../components/PageBanner";

export default function PlayerRegisterSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const playerName = location.state?.name || "Player";

  // Since lucide-react is not installed, I'll use a simple SVG checkmark
  const CheckCircleIcon = () => (
    <svg 
      className="w-20 h-20 text-green-500 mx-auto" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="2" 
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
  );

  return (
    <>
      <PageBanner
        title="Registration Successful!"
        subtitle={`Thank you ${playerName} for registering with Ranipet District Chess Academy`}
        image="/images/chess.png"
      />
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4 pt-0">
        <div className="max-w-lg w-full bg-white rounded-3xl shadow-2xl p-8 sm:p-10 text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <CheckCircleIcon />
          </div>

          {/* Message */}
          <p className="text-gray-600 text-base sm:text-lg mb-6 leading-relaxed">
            Your registration with <span className="font-semibold text-blue-600">
              Ranipet District Chess Academy
            </span> is almost complete!
          </p>

          {/* Status Box */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 text-sm sm:text-base">
            <p>
              🟡 <b>Status:</b> INACTIVE
            </p>
            <p>
              💳 <b>Payment:</b> PENDING
            </p>
            <p className="mt-2 text-gray-500">
              Your profile will be activated after admin verification and payment confirmation.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => navigate("/")}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition-all"
            >
              Back to Home
            </button>

            <button
              onClick={() => navigate("/players/register")}
              className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50 py-3 rounded-xl font-semibold transition-all"
            >
              Register Another Player
            </button>
          </div>
        </div>
      </div>
    </>
  );
}